import React from 'react';


type PlainHTMLDialogProps = {
    html: string,
}

const PlainHTMLDialog = ({html}: PlainHTMLDialogProps) => {
    return (
        <div
            dangerouslySetInnerHTML={{
                __html: html
            }}
        />
    );
};

export default PlainHTMLDialog;
